<script setup>
import { computed, defineProps } from "vue";

// Define props
const props = defineProps({
    label: {
        type: String,
        default: "",
    },
    name: {
        type: String,
        default: "",
    },
    isChecked: {
        type: Boolean,
        default: false,
    },
    value: {
        type: String,
        default: null,
    },
    size: {
        type: String,
        default: "md",
    },
    disabled: {
        type: Boolean,
        default: false,
    },
});

const classes = computed(() => {
    return {
        [`qmodii-label-for-${props.name}`]: props.name,
        [`qmodii-label-item-${props.label.toLowerCase().split(" ").join("-")}`]: props.label,
        [`qmodii-checkbox-${props.size}`]: true,
        "is-checked": props.isChecked,
        "qmodii-disabled": props.disabled,
    };
});
</script>

<template lang="pug">
.qmodii-checkbox(:class="[classes, props.class]")
    label.qmodii-checkbox-label
        input.qmodii-checkbox-input(
            type="checkbox",
            :checked="props.isChecked",
            :name="props.name",
            :aria-label="props.label",
            :value="props.value",
            @change="$emit('update:isChecked', $event.target.checked)"
        )
        span.qmodii-checkbox-custom(aria-hidden="true")
            i.qmodii-icon.qm_icon-checkmark-reg(aria-hidden="true")
        span.qmodii-checkbox-text(aria-hidden="true") {{ props.label }}
</template>

<style lang="stylus">
:root .qmodii-main
    --qmodii-checkbox-border var(--qmodii-secondary-border)

.qmodii-checkbox
    cursor pointer
    
    .qmodii-checkbox-label
        display flex
        align-items center
        cursor pointer

        &:focus-within .qmodii-checkbox-custom
            outline 2px solid var(--qmodii-primary)
            border-radius var(--qmodii-border-radius-sm)
            outline-offset 2px

        .qmodii-checkbox-input
            opacity 0
            position absolute
            margin 0
            cursor pointer

        .qmodii-checkbox-custom
            position relative
            width 21px
            height 21px
            min-width 21px
            min-height 21px
            background-color #fff
            border var(--qmodii-primary-border)
            border-radius 3px
            margin-right 8px
            display flex
            align-items center
            justify-content center
            user-select none
            transition background-color 0.3s ease

            i.qmodii-icon
                display none
                transform scale(0)
                transition transform 0.3s ease
                color white
                font-weight bold
                font-size 12px

    &.qmodii-checkbox-sm
        .qmodii-checkbox-label
            .qmodii-checkbox-custom
                width 16px
                height 16px
                min-width 16px
                min-height 16px

                i.qmodii-icon
                    font-size 10px

    &.is-checked
        .qmodii-checkbox-label
            .qmodii-checkbox-custom
                background-color var(--qmodii-primary)
                color #fff
                border 0

                i.qmodii-icon
                    display flex
                    align-items center
                    transform scale(1)
                    transition transform 0.3s ease
                    transition-delay 1s

    &.qmodii-disabled
        pointer-events none
        cursor not-allowed

        .qmodii-checkbox-label
            pointer-events none
            cursor not-allowed

            .qmodii-checkbox-custom
                border 1px solid #E3E3E3
                opacity 0.4
</style>
